import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastObject } from 'src/app/interfaces/toast-object';
import { TranslationService } from 'src/app/services/translation.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'notification-toast',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './notification-toast.component.html',
  styleUrl: './notification-toast.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationToastComponent implements OnInit, OnDestroy {

  toastType: any;
  desciption: any;
  showToast: boolean = false;
  toastMessageSubscribe: any;
  translationToastMessage: any;
  toastIcon: any = {
    Success: 'img/successIcon.svg',
    Error: 'img/errorIcon.svg',
    Alert: 'img/alertIcon.svg'
  }

  toastIconCss: any = {
    Success: 'toast-icon success',
    Error: 'toast-icon error',
    Alert: 'toast-icon alert'
  }

  constructor(private utilService: UtilService,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService
  ) {

  }

  ngOnInit() {
    this.translationToastMessage = this.translationService.getTranslationForPage('toastMessage');
    this.toastMessageSubscribe = this.utilService.toastMessage$.subscribe((toastObject: ToastObject) => {
      if (toastObject) {
        this.showToast = true;
        this.toastType = toastObject.type;
        this.desciption = toastObject.description;
        this.cdr.markForCheck();
        setTimeout(() => {
          this.showToast = false;
          this.cdr.markForCheck();
        }, 5000);
      }
    });
  }

  closeToast() {
    this.showToast = false;
  }

  ngOnDestroy(): void {
    this.toastMessageSubscribe?.unsubscribe();
  }

}
